import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PaymentGateway } from "./PaymentGatewayAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const paymentGatewayAsync = createAsyncThunk(
  "paymentGateway/add",
  async (uuid) => {
    try {
      const data = await PaymentGateway(uuid);
      // console.log("data in slice", data);
      return data;
    } catch (error) {
      // console.log("errorL :", error);
      // return rejectWithValue(error.message);
    }
  }
);

const PaymentGatewaySlice = createSlice({
  name: "paymentGateway",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(paymentGatewayAsync.fulfilled, (state, action) => {
        state.data?.push(action.payload);
      })
      .addCase(paymentGatewayAsync.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});
// export const selectEmployerLogo = (state) => state.employerLogo.data;

export default PaymentGatewaySlice.reducer;
